// import { useForm } from "hooks/useForm"
import axios from 'axios';
import Button from 'blocks/Button';
import Card from 'blocks/Card';
import { Divider } from 'blocks/CommonLayout';
import { RowItem } from 'blocks/Row';
import { Title } from 'blocks/Text';
import Form, { DatePicker, InputWrapper, SelectField, TextField } from 'components/Form';
import dayjs from 'dayjs';
import Paths from 'helper/paths';
import Auth from 'layouts/Auth';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { NATIONALITY, TITLE_MENU } from 'utils/constants';
import urls from 'utils/urls';
import ModalVerifyCode from './components/ModalVerifyCode';
import ModalVerifyEmail from './components/ModalVerifyEmail';
import { SignupFormModel } from './signup.interface';
import * as S from './signup.styles';

import isBetween from 'dayjs/plugin/isBetween';
import ModalNotificationParent from './components/ModalNotificationParent';
import ModalVerifyKides from './components/ModalVerifyKides';
dayjs.extend(isBetween);
const Signup = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { register, setValue, handleSubmit, getValues, watch } = useForm<SignupFormModel>();
  const [defultValueFlie, setDefultValueFlie] = useState(t('pages.signup.sections.form.nofile'));
  const [loading, setLoading] = useState(false);
  const [dataSign, setDataSign] = useState<SignupFormModel>({ ...getValues() });
  const [dataSignKides, setDataSignKides] = useState<SignupFormModel>({ ...getValues() });
  const [verifyLoading, setVerifyLoading] = useState<boolean>(false);
  const [showModalVerifyCode, setShowModalVerifyCode] = useState(false);
  const [showModalVerifyKide, setShowModalVerifyKide] = useState(false);
  const [showModalVerifyEmail, setShowModalVerifyEmail] = useState(false);
  const [notificationMessageParent, setNotificationMessageParent] = useState(false);
  const [redirectLogin, setRedirectLogin] = useState(false);
  // let dataSign: SignupFormModel;
  const getVerifyCode = (data: SignupFormModel) => {
    const dataToSend = {
      ...data,
      password: data.password || (document.getElementById('password') as HTMLInputElement).value,
      enFname: (data && data.enFname) || (document.getElementById('enFname') as HTMLInputElement).value,
      enLname: (data && data.enLname) || (document.getElementById('enLname') as HTMLInputElement).value,
      mobile: (data && data.mobile) || (document.getElementById('mobile') as HTMLInputElement).value,
      email: (data && data.email) || (document.getElementById('email') as HTMLInputElement).value,
      birthdate: (data && data.birthdate) || (document.getElementById('birthdate') as HTMLInputElement).value,
      docId: (data && data.docId) || (document.getElementById('docId') as HTMLInputElement).value,
      nationality: (data && data.nationality) || (document.getElementById('nationality') as HTMLInputElement).value,
      title: (data && data.title) || (document.getElementById('title') as HTMLInputElement).value,
      confirmPassword:
        (data && data.confirmPassword) || (document.getElementById('confirmPassword') as HTMLInputElement).value,
      docExpireDate:
        (data && data.docExpireDate) || (document.getElementById('docExpireDate') as HTMLInputElement).value,
      passportIssuingCountry:
        (data && data.passportIssuingCountry) ||
        (document.getElementById('passportIssuingCountry') as HTMLInputElement).value,
    };
    // dataSign = { ...dataToSend };

    setDataSign(dataToSend);
    if (!dataToSend.password) {
      setLoading(false);
      return toast.error('Password is empty');
    } else if (hasPersianChar(dataToSend.enFname)) {
      setLoading(false);
      toast.error('First name must be english');
    } else if (!dataToSend.enFname) {
      setLoading(false);
      return toast.error('First name is empty');
    } else if (!dataToSend.enLname) {
      setLoading(false);
      return toast.error('Surname is empty');
    } else if (hasPersianChar(dataToSend.enLname)) {
      setLoading(false);
      toast.error('Surname must be english');
    } else if (!dataToSend.email) {
      setLoading(false);
      return toast.error('Email is empty');
    } else if (!dataToSend.mobile) {
      setLoading(false);
      return toast.error('Mobile number is empty');
    } else if (!dataToSend.birthdate) {
      setLoading(false);
      return toast.error('Date of birth is empty');
    } else if (!dataToSend.docId) {
      setLoading(false);
      return toast.error('National id is empty');
    } else if (!dataToSend.nationality) {
      setLoading(false);
      return toast.error('Nationality is empty');
    } else if (!dataToSend.title) {
      setLoading(false);
      return toast.error('Title is empty');
    } else if (!dataToSend.confirmPassword) {
      setLoading(false);
      return toast.error('Confirm Password is empty');
    } else if (
      (!dataToSend.password && !dataToSend.confirmPassword) ||
      dataToSend.password !== dataToSend.confirmPassword
    ) {
      setLoading(false);
      return toast.error(t('pages.signup.sections.form.errors.notSamePassword'));
    } else if (!dataToSend.docExpireDate) {
      setLoading(false);
      return toast.error('Passport expiration date is empty');
    } else if (!dataToSend.passportIssuingCountry) {
      setLoading(false);
      return toast.error('Passport issuing country is empty');
    } else if (data.nationality.toUpperCase() === 'IR' && !data.nationalId) {
      toast.error('Please fill National ID field');
    } else {
      setLoading(true);
      axios
        .post(urls.sendCode, { mobile: dataToSend.mobile })
        .then(() => setShowModalVerifyCode(true))
        .finally(() => setLoading(false));
      setShowModalVerifyCode(true);
    }
  };
  console.log(getValues('file'));

  // useEffect(() => {
  //   if (getValues('file')) setDefultValueFlie(getValues('file')['name']);
  // }, [getValues('file')]);

  const getConfirmationKides = (data: SignupFormModel) => {
    const dataToSend = {
      ...data,
      parentNo: data.parentNo || (document.getElementById('parentNo') as HTMLInputElement).value,
      file: (data && data.file) || (document.getElementById('file') as HTMLInputElement).value,
      password: data.password || (document.getElementById('password') as HTMLInputElement).value,
      enFname: (data && data.enFname) || (document.getElementById('enFname') as HTMLInputElement).value,
      enLname: (data && data.enLname) || (document.getElementById('enLname') as HTMLInputElement).value,
      // mobile: (data && data.mobile) || (document.getElementById('mobile') as HTMLInputElement).value,
      // email: (data && data.email) || (document.getElementById('email') as HTMLInputElement).value,
      birthdate: (data && data.birthdate) || (document.getElementById('birthdate') as HTMLInputElement).value,
      docId: (data && data.docId) || (document.getElementById('docId') as HTMLInputElement).value,
      nationality: (data && data.nationality) || (document.getElementById('nationality') as HTMLInputElement).value,
      title: (data && data.title) || (document.getElementById('title') as HTMLInputElement).value,
      confirmPassword:
        (data && data.confirmPassword) || (document.getElementById('confirmPassword') as HTMLInputElement).value,
      docExpireDate:
        (data && data.docExpireDate) || (document.getElementById('docExpireDate') as HTMLInputElement).value,
      passportIssuingCountry:
        (data && data.passportIssuingCountry) ||
        (document.getElementById('passportIssuingCountry') as HTMLInputElement).value,
    };
    // dataSign = { ...dataToSend };
    setDataSignKides(dataToSend);
    if (!dataToSend.password) {
      setLoading(false);
      return toast.error('Password is empty');
    } else if (hasPersianChar(dataToSend.enFname)) {
      setLoading(false);
      toast.error('First name must be english');
    } else if (!dataToSend.parentNo) {
      setLoading(false);
      toast.error('Parent number must is empty');
    } else if (!dataToSend.file) {
      setLoading(false);
      toast.error('Upload file must is empty');
    } else if (!dataToSend.enFname) {
      setLoading(false);
      return toast.error('First name is empty');
    } else if (!dataToSend.enLname) {
      setLoading(false);
      return toast.error('Surname is empty');
    } else if (hasPersianChar(dataToSend.enLname)) {
      setLoading(false);
      toast.error('Surname must be english');
    } else if (!dataToSend.birthdate) {
      setLoading(false);
      return toast.error('Date of birth is empty');
    } else if (!dataToSend.docId) {
      setLoading(false);
      return toast.error('National id is empty');
    } else if (!dataToSend.nationality) {
      setLoading(false);
      return toast.error('Nationality is empty');
    } else if (!dataToSend.title) {
      setLoading(false);
      return toast.error('Title is empty');
    } else if (!dataToSend.confirmPassword) {
      setLoading(false);
      return toast.error('Confirm Password is empty');
    } else if (
      (!dataToSend.password && !dataToSend.confirmPassword) ||
      dataToSend.password !== dataToSend.confirmPassword
    ) {
      setLoading(false);
      return toast.error(t('pages.signup.sections.form.errors.notSamePassword'));
    } else if (!dataToSend.docExpireDate) {
      setLoading(false);
      return toast.error('Passport expiration date is empty');
    } else if (!dataToSend.passportIssuingCountry) {
      setLoading(false);
      return toast.error('Passport issuing country is empty');
    } else if (data.nationality.toUpperCase() === 'IR' && !data.nationalId) {
      toast.error('Please fill National ID field');
    } else {
      setLoading(true);
      setShowModalVerifyKide(true);
    }
  };

  const submitForm = (code) => {
    if (!code) toast.error('Please Fill Form Input');
    // dataSign.code = code;
    signup({ ...dataSign, code: code });
  };

  const signup = async (payload: SignupFormModel) => {
    setVerifyLoading(true);

    const data = {
      ...payload,
      faFname: payload.enFname,
      faLname: payload.enLname,
    };

    if (data.nationality !== 'IR') {
      delete data.fatherName;
      delete data.nationalId;
      delete data.personId;
    }

    delete data.confirmPassword;

    axios
      .post(urls.signup, data)
      .then((res) => {
        setShowModalVerifyEmail(true);
      })
      .catch((ex) => {
        toast.error(ex.response?.data?.message);
      })
      .finally(() => {
        setVerifyLoading(false);
        setLoading(false);
        setShowModalVerifyCode(false);
      });
  };
  const signupKides = async (payload: SignupFormModel) => {
    const formData = new FormData();
    const data = {
      ...payload,
      faFname: payload.enFname,
      faLname: payload.enLname,
      file: payload.file,
    };
    console.log(payload, 'payload');

    if (data.nationality !== 'IR') {
      delete data.fatherName;
      delete data.nationalId;
      delete data.personId;
    }

    delete data.confirmPassword;
    delete data.email;
    delete data.mobile;
    delete data.zipCode;
    delete data.address;

    Object.keys(data).forEach((key) => {
      console.log(key, data[key]);
      return formData.append(key, data[key]);
    });

    axios
      .post(urls.kidsSignup, formData)
      .then((res) => {
        navigate(Paths.Login.index().route);
      })
      .catch((ex) => {
        toast.error(ex.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const hasPersianChar = (str) => {
    const match = str.match(/[^a-zA-Z]/);
    return match ? true : false;
  };

  const handelNotPersian = (e) => {
    const match = e.key.match(/[a-zA-Z]/);
    if (match) return;
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    e.preventDefault();
  };

  const SideFooter = () => {
    return (
      <>
        {t('pages.signup.sections.image.loginDescription')}
        <Link to={Paths.Login.index().route}> {t('pages.signup.sections.image.toLoginCTA')}</Link>
      </>
    );
  };
  const SignupForm = () => {
    return (
      <>
        <S.SignupFormContainer as={RowItem} gap={false}>
          <Card space="lg">
            <S.SignupTitle as={Title} size="medium" bold={false}>
              {t('pages.signup.sections.form.title')}
            </S.SignupTitle>
            <S.SignupForm as={Form}>
              <InputWrapper>
                <TextField
                  id={'enFname'}
                  required
                  control={register('enFname')}
                  fullWidth
                  label={t('pages.signup.sections.form.fields.firstName.label')}
                  inputProps={{
                    onKeyDown: (e) => {
                      handelNotPersian(e);
                    },
                  }}
                />
                <TextField
                  id={'enLname'}
                  required
                  control={register('enLname')}
                  fullWidth
                  label={t('pages.signup.sections.form.fields.lastName.label')}
                  inputProps={{
                    onKeyDown: (e) => {
                      handelNotPersian(e);
                    },
                  }}
                />
              </InputWrapper>
              <InputWrapper>
                <SelectField
                  id={'nationality'}
                  control={register('nationality')}
                  label={t('pages.signup.sections.form.fields.nationality.label')}
                  onChange={(value: string) => setValue('nationality', value)}
                  autoCompelete
                  menu={NATIONALITY}
                  defaultValue={getValues('nationality')}
                  required
                />
                <SelectField
                  id="title"
                  label={t('pages.signup.sections.form.fields.title.label')}
                  onChange={(value: string) => setValue('title', value)}
                  menu={TITLE_MENU}
                  defaultValue={getValues('title')}
                  required
                />
              </InputWrapper>
              {watch('nationality') && getValues('nationality').toLocaleLowerCase() === 'ir' ? (
                <>
                  <InputWrapper>
                    <TextField
                      dir={'ltr'}
                      fullWidth
                      control={register('personId')}
                      label={t('pages.signup.sections.form.fields.personId.label')}
                    />
                    <TextField
                      dir={'ltr'}
                      id="nationalId"
                      required
                      fullWidth
                      label={t('pages.signup.sections.form.fields.nationalId.label')}
                      control={register('nationalId')}
                    />
                  </InputWrapper>
                  <InputWrapper>
                    <TextField
                      fullWidth
                      label={t('pages.signup.sections.form.fields.fatherName.label')}
                      control={register('fatherName')}
                    />
                  </InputWrapper>
                </>
              ) : null}
              <InputWrapper>
                <DatePicker
                  dir={'ltr'}
                  id={'birthdate'}
                  label={t('pages.signup.sections.form.fields.birthdate.label')}
                  onChange={(value) => {
                    if (dayjs(value).isAfter(dayjs().add(-2, 'year'))) {
                      toast.error(t('pages.signup.sections.form.errors.lessTowYear'));
                    }
                    setValue('birthdate', value);
                  }}
                  defaultValue={getValues('birthdate')}
                  maxDate={new Date().getTime()}
                  required={true}
                />
                <SelectField
                  id="passportIssuingCountry"
                  label={t('pages.signup.sections.form.fields.passportCountry.label')}
                  onChange={(value: string) => setValue('passportIssuingCountry', value)}
                  autoCompelete
                  defaultValue={getValues('passportIssuingCountry')}
                  menu={NATIONALITY}
                  required
                />
              </InputWrapper>
              <InputWrapper>
                <TextField
                  dir={'ltr'}
                  id="docId"
                  fullWidth
                  required
                  control={register('docId')}
                  label={t('pages.signup.sections.form.fields.passportNo.label')}
                />
                <DatePicker
                  dir={'ltr'}
                  id={'docExpireDate'}
                  label={t('pages.signup.sections.form.fields.docExpireDate.label')}
                  onChange={(value) => setValue('docExpireDate', value)}
                  required={true}
                />
              </InputWrapper>
              {watch('birthdate') &&
              dayjs(getValues('birthdate')).isBetween(dayjs().add(-12, 'year'), dayjs().add(-2, 'year')) ? (
                ''
              ) : (
                <InputWrapper>
                  <TextField
                    dir={'ltr'}
                    fullWidth
                    control={register('zipCode')}
                    label={t('pages.signup.sections.form.fields.zipCode.label')}
                  />
                  <TextField
                    fullWidth
                    control={register('address')}
                    label={t('pages.signup.sections.form.fields.address.label')}
                  />
                </InputWrapper>
              )}
              {watch('birthdate') &&
              dayjs(getValues('birthdate')).isBetween(dayjs().add(-12, 'year'), dayjs().add(-2, 'year')) ? (
                <InputWrapper>
                  <TextField
                    dir={'ltr'}
                    id="parentNo"
                    fullWidth
                    required
                    control={register('parentNo')}
                    label={t('pages.signup.sections.form.fields.parentNo.label')}
                  />

                  <TextField
                    dir={'ltr'}
                    id="file"
                    fullWidth
                    type="file"
                    required
                    onChange={(value: any) => {
                      console.log(value.target.files);
                      setValue('file', value.target.files[0]);
                      setDefultValueFlie(getValues('file')['name']);
                    }}
                    nameFile={defultValueFlie}
                    // defaultValue={getValues('file')}
                    label={t('pages.signup.sections.form.fields.uploadFile.label')}
                  />
                </InputWrapper>
              ) : (
                <>
                  <Divider space="large" />
                  <InputWrapper>
                    <TextField
                      dir={'ltr'}
                      id="email"
                      fullWidth
                      required
                      control={register('email')}
                      label={t('pages.signup.sections.form.fields.email.label')}
                    />
                    <TextField
                      dir={'ltr'}
                      id="mobile"
                      fullWidth
                      required
                      control={register('mobile', {
                        required: t('pages.signup.sections.form.fields.mobile.emptyError') as string,
                      })}
                      label={t('pages.signup.sections.form.fields.mobile.label')}
                    />
                  </InputWrapper>
                </>
              )}
              <Divider space="large" />
              <InputWrapper>
                <TextField
                  dir={'ltr'}
                  id="password"
                  required
                  fullWidth
                  type="password"
                  control={register('password')}
                  label={t('pages.signup.sections.form.fields.password.label')}
                />
                <TextField
                  dir={'ltr'}
                  id="confirmPassword"
                  required
                  fullWidth
                  type="password"
                  control={register('confirmPassword')}
                  label={t('pages.signup.sections.form.fields.passwordConfirmation.label')}
                />
              </InputWrapper>
              <Divider space="large" />
              <S.RepresentiveForm>
                <TextField
                  dir={'ltr'}
                  fullWidth
                  label={t('pages.signup.sections.representive.form.fields.label')}
                  control={register('referal')}
                />
                <S.FormAnnouncement>{t('pages.signup.sections.representive.description')}</S.FormAnnouncement>
              </S.RepresentiveForm>
              <S.SignupFormButton>
                <Button
                  width={176}
                  loading={loading}
                  onClick={handleSubmit((data) => {
                    if (dayjs(data.birthdate).isBetween(dayjs().add(-12, 'year'), dayjs().add(-2, 'year'))) {
                      getConfirmationKides(data);
                    }
                    getVerifyCode(data);
                  })}
                >
                  {t('pages.signup.sections.form.submitCTA')}
                </Button>
                <S.sendtoLoginPage as={Link} to={Paths.Login.index().route}>
                  {' '}
                  {t('pages.signup.sections.form.loginDescription')}
                </S.sendtoLoginPage>
              </S.SignupFormButton>
            </S.SignupForm>
          </Card>
        </S.SignupFormContainer>
        <ModalVerifyKides
          open={showModalVerifyKide}
          onClose={() => setShowModalVerifyKide(false)}
          setNotificationMessageParent={setNotificationMessageParent}
        />
        <ModalNotificationParent
          open={notificationMessageParent}
          onClose={() => setNotificationMessageParent(false)}
          onSubmit={() => signupKides(dataSignKides)}
        />
        <ModalVerifyCode
          open={showModalVerifyCode}
          loading={verifyLoading}
          onClose={() => setShowModalVerifyCode(false)}
          onSubmit={(code) => submitForm(code)}
        />
        <ModalVerifyEmail
          open={showModalVerifyEmail}
          // loading={verifyLoading}
          onClose={() => setShowModalVerifyEmail(false)}
          setRedirectLogin={setRedirectLogin}
        />
      </>
    );
  };

  return (
    <Auth
      topTitle={t('pages.signup.sections.image.topTitle')}
      title={t('pages.signup.sections.image.title')}
      children={SignupForm()}
      sideFooter={SideFooter()}
    />
  );
};

export default Signup;
